import { takeLeading, select, put } from 'redux-saga/effects';
import { REQUEST_GET_DOC_BY_DOCUMENTUM_ID } from 'containers/common/UploadDocument/constants';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';

import {
  startLoading,
  stopLoading,
} from 'containers/AppContainer/Loader/action';
import { getTokenFromUserStorage, constructUrlV2 } from 'services/utils';

export function* requestGetDocByDocumentumId(action: any): Generator<unknown> {
  try {
    yield put(startLoading());
    const token =
      getTokenFromUserStorage() || (yield select(makeSelectKeycloakToken()));
    const url = constructUrlV2(action.url);

    yield fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => res.blob())
      .then(blob => {
        var _url = window.URL.createObjectURL(blob);
        //@ts-ignore
        window.open(_url, '_blank');
      })
      .catch(err => {
        throw err;
      });
  } catch (err) {
  } finally {
    yield put(stopLoading());
  }
}
export function* requestGetDocByDocumentumIdSaga() {
  yield takeLeading(
    REQUEST_GET_DOC_BY_DOCUMENTUM_ID,
    requestGetDocByDocumentumId,
  );
}

export default [requestGetDocByDocumentumIdSaga];
